import deps from "../depsloader";

export default () => {
  deps.load("lightgallery").then(() => {
    const elms = document.querySelectorAll(".lightgallery");
    if (elms) {
      for (let element of elms) {
        let config = null;
        if (element.dataset.config) {
          config = element.dataset.config;
          element.removeAttribute("data-config");
        }

        lightGallery(element, JSON.parse(config)); // eslint-disable-line
      }
    }

    const gallerys = document.querySelectorAll(".blocks-gallery-grid");
    if (gallerys) {
      for (let element of gallerys) {
        let config = {
          "selector":"a"
        };

        lightGallery(element, config); // eslint-disable-line
      }
    }

    const imw = document.querySelectorAll(".immowelt-auszeichnung");
    if (imw) {
      for (let element of imw) {
        let config = {
          "selector":"a"
        };

        lightGallery(element, config); // eslint-disable-line
      }
    }

    const ifr = document.querySelectorAll(".iframe-popup");
    if (ifr) {
      for (let element of ifr) {
        for (var item of element.getElementsByTagName("a")) {
          if (item) {
            item.setAttribute("data-iframe", "true");
          }
        }

        let config = {
          "selector": "a",
          "iframeMaxWidth": "100%"
        };

        lightGallery(element, config); // eslint-disable-line
      }
    }




    const exposeBtn = document.querySelector("#exGalleryBtn");
    if (exposeBtn) {
      exposeBtn.addEventListener("click", function(e) {
        e.preventDefault();
        const gallery = document.querySelector("#exGallery");
        if (gallery) {
          gallery.firstElementChild.click();
        }
      })
    }
  });
}
